import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreAllStudents as apiFn } from "../../api/apiStudents";
import { useSnackbar } from "notistack"; import getErrorMessageFromAxiosError from "../../utils/parseError";
export function useRestoreAllStudents() { const qc = useQueryClient(); const { enqueueSnackbar } = useSnackbar();
    const { mutate: restoreAllStudents, isPending: isRestore } = useMutation({ mutationFn: (req) => apiFn(req),
        onSuccess: (r) => { enqueueSnackbar(r.message, { variant: "success" }); qc.invalidateQueries({ queryKey: ["students"] }); },
        onError: (err) => { enqueueSnackbar(getErrorMessageFromAxiosError(err), { variant: "error" }); } });
    return { restoreAllStudents, isRestore }; }
